import { makeStyles } from "@material-ui/core"

export const auditBulkStyles = makeStyles((theme) => ({

    
}));